export class UninitializedContextError extends Error {
  constructor(contextName: string) {
    super(`Uninitialized context: ${contextName}`);
  }
}

export const uninitializedContextErrorFn = (contextName: string) => () =>
  throwUninitializedContextError(contextName);

const throwUninitializedContextError = (contextName: string) => {
  throw new UninitializedContextError(contextName);
};
